module.exports = __webpack_public_path__ + "static/img/1-1Z52F95Q6409.8ccf3f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1-1Z52F95Q6409.jpg
// module id = Un0T
// module chunks = 0